import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { fetchVoucherContent } from 'Pages/InfoVoucherPage/Redux/thunks';
import { getIsFetching, getVoucherContent } from 'Pages/InfoVoucherPage/Redux/selectors';
import InfoVoucherPage from 'Pages/InfoVoucherPage/InfoVoucherPage';

interface IPropsInternal {
  isFetching: boolean;
  voucherContent: Julius.Content.VoucherPage;
  fetchVoucherContent: () => void;
}

type Props = IPropsInternal & RouteComponentProps<{}>;

class InfoVoucherPageContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchVoucherContent();
  }

  render() {
    const { voucherContent, isFetching } = this.props;
    const descriptionText = voucherContent ? voucherContent.descriptionText : null;
    const descriptionImageUrl = voucherContent ? voucherContent.descriptionImageUrl : null;

    return (
      <InfoVoucherPage 
        isFetching={ isFetching }
        descriptionText={ descriptionText }
        descriptionImageUrl={ descriptionImageUrl }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    voucherContent: getVoucherContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchVoucherContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoVoucherPageContainer);


// WEBPACK FOOTER //
// ./src/pages/InfoVoucherPage/InfoVoucherPageContainer.tsx